var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-block w-100 text-center"},[_c('font-awesome-icon',{class:_vm.params.class,attrs:{"icon":_vm.params.icon,"size":_vm.params.size ? _vm.params.size : 'md'},on:{"click":_vm.click}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }